import { Spacer } from 'app/layouts/generic';
import { GridColumn, GridRow } from 'app/layouts/grid';
import SlidingNav from 'app/shared/nav/sliding/sliding';
import React from 'react';
import { Route, Routes, useParams } from 'react-router-dom';
import { MobilePushBasicInfo } from './details/basic';
import { MobilePushMessageStatBar } from './statbar';
import { MobilePushMessageLogs } from './logs/sent';

const getNavItems = (message_id) => [
  {
    title: 'Recipients',
    path: `/mobile/${message_id}`
  }
];

export const MobilePushMessageViewPage = () => {
  const { id } = useParams();

  return (
    <>
      <GridRow>
        <GridColumn>
          <MobilePushBasicInfo id={id} />
        </GridColumn>
        <GridColumn span={3}>
          <GridRow num_of_columns={1}>
            <MobilePushMessageStatBar id={id} />
          </GridRow>
          <Spacer multiple={4} />
          <GridRow num_of_columns={1}>
            <SlidingNav nav_items={getNavItems(id)} />
            <Routes>
              <Route path="/*" element={<MobilePushMessageLogs id={id} />} />
            </Routes>
          </GridRow>
        </GridColumn>
      </GridRow>
    </>
  );
};
